import { ApiOnboardingStep } from "@incendium/api";

export const approvedMap = {
  [ApiOnboardingStep.BASIC_INFO]: "basicInfoApproved",
  [ApiOnboardingStep.BUSINESS_INFO]: "businessInfoApproved",
  [ApiOnboardingStep.PLATFORM]: "platformApproved",
  [ApiOnboardingStep.PIXEL]: "pixelApproved",
  [ApiOnboardingStep.LOCATIONS]: "locationsApproved",
  [ApiOnboardingStep.CONNECTIONS]: "connectionsApproved",
};
